"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcPaymentHeader = class UcPaymentHeader extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    payment;
    onPayment(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("payment");
    }
    config;
    onConfig(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("config");
    }
    ux;
    dataMembers = ['ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ux: null,
            },
        };
    }
    get isNew() {
        if (this.loaded) {
            return !this.payment.id;
        }
        return null;
    }
    get isPettyCash() {
        if (this.loaded) {
            return this.payment.transaction_kind === 'cash_book';
        }
        return null;
    }
    get resourceKey() {
        if (this.loaded) {
            return this.isNew ? this.config.newTransaction : this.payment.snapshot('transaction_number');
        }
        return null;
    }
    async act_1040167445267876_emit_7904_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_1040167445267876_clickPreventStop(event, scope) {
        return await this.actions.evh_1040167445267876_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_4186377094414664_emit_7906_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_4186377094414664_success(event, scope) {
        return await this.actions.evh_4186377094414664_success.executeFromDOM(this, event, scope);
    }
    async act_1506888955587522_setData_7910_getActionArgs($event) {
        return {
            path: "item",
            value: $event && $event.data,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_1506888955587522_success_7909_getWhen($event) {
        return !!$event.data;
    }
    async act_1506888955587522_reloadSlickgrid_7912_getActionArgs($event) {
        return {
            grid: "payments",
        };
    }
    async evh_1506888955587522_success_7911_getWhen($event) {
        return !!$event.data;
    }
    async act_1506888955587522_rest_7908_getActionArgs($event) {
        return {
            method: "save",
            container: {
                self: this.payment.links.parent,
                object: 'list',
                data: []
            },
            resource: this.payment,
            data: {
                etag: this.payment.etag,
                complete: true,
            },
        };
    }
    async act_1506888955587522_rest_7908_getConfirm($event) {
        return {
            header: this.dialogHeader,
            message: this.$fn.gettext("Completing prevents further modifications. Please confirm this operation."),
            btnOk: this.$fn.gettext("Complete"),
            severity: "warning",
        };
    }
    async evh_1506888955587522_clickPreventStop(event, scope) {
        return await this.actions.evh_1506888955587522_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_3306541085110264_emit_7914_getActionArgs($event) {
        return {
            event: "deleted",
        };
    }
    async evh_3306541085110264_success(event, scope) {
        return await this.actions.evh_3306541085110264_success.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_1040167445267876_emit_7904 = new core_1.actions.EmitAction({
            actionArgs: this.act_1040167445267876_emit_7904_getActionArgs,
            displayName: "reload",
            events: [],
        });
        const evh_1040167445267876_clickPreventStop_7903 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_emit_7904,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_1040167445267876_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_clickPreventStop_7903],
        });
        const act_4186377094414664_emit_7906 = new core_1.actions.EmitAction({
            actionArgs: this.act_4186377094414664_emit_7906_getActionArgs,
            events: [],
        });
        const evh_4186377094414664_success_7905 = new core_1.actions.EventHandlerImpl({
            action: act_4186377094414664_emit_7906,
            event: "success",
            displayName: "emit",
        });
        const evh_4186377094414664_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4186377094414664_success_7905],
        });
        const act_1506888955587522_setData_7910 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1506888955587522_setData_7910_getActionArgs,
            events: [],
        });
        const evh_1506888955587522_success_7909 = new core_1.actions.EventHandlerImpl({
            action: act_1506888955587522_setData_7910,
            event: "success",
            when: this.evh_1506888955587522_success_7909_getWhen,
            displayName: "setData",
        });
        const act_1506888955587522_reloadSlickgrid_7912 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1506888955587522_reloadSlickgrid_7912_getActionArgs,
            events: [],
        });
        const evh_1506888955587522_success_7911 = new core_1.actions.EventHandlerImpl({
            action: act_1506888955587522_reloadSlickgrid_7912,
            event: "success",
            when: this.evh_1506888955587522_success_7911_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_1506888955587522_rest_7908 = new core_1.actions.RestAction({
            actionArgs: this.act_1506888955587522_rest_7908_getActionArgs,
            confirm: this.act_1506888955587522_rest_7908_getConfirm,
            displayName: "complete",
            events: [evh_1506888955587522_success_7909, evh_1506888955587522_success_7911],
        });
        const evh_1506888955587522_clickPreventStop_7907 = new core_1.actions.EventHandlerImpl({
            action: act_1506888955587522_rest_7908,
            event: "click.prevent.stop",
            displayName: "complete",
        });
        const evh_1506888955587522_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1506888955587522_clickPreventStop_7907],
        });
        const act_3306541085110264_emit_7914 = new core_1.actions.EmitAction({
            actionArgs: this.act_3306541085110264_emit_7914_getActionArgs,
            events: [],
        });
        const evh_3306541085110264_success_7913 = new core_1.actions.EventHandlerImpl({
            action: act_3306541085110264_emit_7914,
            event: "success",
            displayName: "emit",
        });
        const evh_3306541085110264_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3306541085110264_success_7913],
        });
        return {
            act_1040167445267876_emit_7904,
            evh_1040167445267876_clickPreventStop_7903,
            evh_1040167445267876_clickPreventStop,
            act_4186377094414664_emit_7906,
            evh_4186377094414664_success_7905,
            evh_4186377094414664_success,
            act_1506888955587522_setData_7910,
            evh_1506888955587522_success_7909,
            act_1506888955587522_reloadSlickgrid_7912,
            evh_1506888955587522_success_7911,
            act_1506888955587522_rest_7908,
            evh_1506888955587522_clickPreventStop_7907,
            evh_1506888955587522_clickPreventStop,
            act_3306541085110264_emit_7914,
            evh_3306541085110264_success_7913,
            evh_3306541085110264_success,
            reload: act_1040167445267876_emit_7904,
            complete: act_1506888955587522_rest_7908,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcPaymentHeader.prototype, "payment", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('payment'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcPaymentHeader.prototype, "onPayment", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcPaymentHeader.prototype, "config", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('config'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcPaymentHeader.prototype, "onConfig", null);
UcPaymentHeader = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcPaymentHeader);
exports.default = UcPaymentHeader;
vue_property_decorator_1.Vue.component("UcPaymentHeader", UcPaymentHeader);
